import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/posts',
  component: Management,
  redirect: '/posts/list',
  children: [
    // 列表页
    {
      path: 'list',
      redirect: 'list/all',
      component: () => import('@/views/posts/List'),
      meta: {
        auth: Auth.listPosts
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/posts/ListTable'),
          meta: {
            auth: Auth.listPosts,
            tabName: 'all'
          }
        },
        {
          path: 'customer_service',
          component: () => import('@/views/posts/ListTable'),
          meta: {
            auth: Auth.listPosts,
            tabName: 'customer_service'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/posts/New'),
      meta: {
        auth: Auth.createPost
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/posts/Edit'),
      meta: {
        auth: Auth.updatePost
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/posts/DetailLayout'),
      meta: {
        auth: Auth.showPost
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/posts/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showPost
          }
        },
        {
          path: 'feedbacks',
          component: () => import('@/views/posts/details/Feedbacks'),
          meta: {
            tabName: 'feedbacks', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showPost
          }
        }
      ]
    }
  ]
}
